/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_contact_alert_file_types = /** @type {(inputs: { authorizedFileTypes: NonNullable<unknown> }) => string} */ (i) => {
	return `Podporované typy souborů jsou ${i.authorizedFileTypes}`
};

const da_contact_alert_file_types = /** @type {(inputs: { authorizedFileTypes: NonNullable<unknown> }) => string} */ (i) => {
	return `Tilladte filtyper er ${i.authorizedFileTypes}`
};

const de_contact_alert_file_types = /** @type {(inputs: { authorizedFileTypes: NonNullable<unknown> }) => string} */ (i) => {
	return `Unterstützte Dateitypen: ${i.authorizedFileTypes}`
};

const en_contact_alert_file_types = /** @type {(inputs: { authorizedFileTypes: NonNullable<unknown> }) => string} */ (i) => {
	return `Supported file types are ${i.authorizedFileTypes}`
};

const es_contact_alert_file_types = /** @type {(inputs: { authorizedFileTypes: NonNullable<unknown> }) => string} */ (i) => {
	return `Los tipos de archivos permitidos son ${i.authorizedFileTypes}`
};

const fr_contact_alert_file_types = /** @type {(inputs: { authorizedFileTypes: NonNullable<unknown> }) => string} */ (i) => {
	return `Les types de fichiers pris en charge sont ${i.authorizedFileTypes}`
};

const hu_contact_alert_file_types = /** @type {(inputs: { authorizedFileTypes: NonNullable<unknown> }) => string} */ (i) => {
	return `A támogatott fájltípusok: ${i.authorizedFileTypes}`
};

const it_contact_alert_file_types = /** @type {(inputs: { authorizedFileTypes: NonNullable<unknown> }) => string} */ (i) => {
	return `I tipi di file supportati sono ${i.authorizedFileTypes}`
};

const nl_contact_alert_file_types = /** @type {(inputs: { authorizedFileTypes: NonNullable<unknown> }) => string} */ (i) => {
	return `Ondersteunde bestandstypen: ${i.authorizedFileTypes}`
};

const pl_contact_alert_file_types = /** @type {(inputs: { authorizedFileTypes: NonNullable<unknown> }) => string} */ (i) => {
	return `Obsługiwane typy plików: ${i.authorizedFileTypes}`
};

const pt_contact_alert_file_types = /** @type {(inputs: { authorizedFileTypes: NonNullable<unknown> }) => string} */ (i) => {
	return `Os tipos de arquivos suportados são ${i.authorizedFileTypes}`
};

const sv_contact_alert_file_types = /** @type {(inputs: { authorizedFileTypes: NonNullable<unknown> }) => string} */ (i) => {
	return `Tillåtna filtyper är ${i.authorizedFileTypes}`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ authorizedFileTypes: NonNullable<unknown> }} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const contact_alert_file_types = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_alert_file_types(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("contact_alert_file_types", locale)
	if (locale === "cs") return cs_contact_alert_file_types(inputs)
	if (locale === "da") return da_contact_alert_file_types(inputs)
	if (locale === "de") return de_contact_alert_file_types(inputs)
	if (locale === "en") return en_contact_alert_file_types(inputs)
	if (locale === "es") return es_contact_alert_file_types(inputs)
	if (locale === "fr") return fr_contact_alert_file_types(inputs)
	if (locale === "hu") return hu_contact_alert_file_types(inputs)
	if (locale === "it") return it_contact_alert_file_types(inputs)
	if (locale === "nl") return nl_contact_alert_file_types(inputs)
	if (locale === "pl") return pl_contact_alert_file_types(inputs)
	if (locale === "pt") return pt_contact_alert_file_types(inputs)
	return sv_contact_alert_file_types(inputs)
};
export { contact_alert_file_types as "contact.alert.file_types" }